import {onMounted, onUnmounted} from "vue";

export function useInterval(callback, ms){
    let tid = undefined;
    onMounted(() => {
        tid = setInterval(callback, ms);
        callback();
    })
    onUnmounted(() => {
        clearInterval(tid);
    })
}